export const BAD_REQUEST = 400;
export const UNAUTHORIZED = 403;
export const NOT_FOUND = 404;

//This is a placeholder when value is empty - it can be changed with any component/image/ect..
export const valueNotSet = "-";
